export class WordPressSiteOriginMissingError extends Error {
  constructor(storeName?: string) {
    super(
      storeName
        ? `O dispensador "${storeName}" não possui URL WordPress configurada.`
        : "Dispensador sem URL WordPress configurada.",
    );
    this.name = "WordPressSiteOriginMissingError";
  }
}

/**
 * Base do site WordPress (sem sufixo REST WooCommerce).
 * `siteOrigin` deve estar configurado em VITE_WOO_ORGANIZATION_STORES — sem fallback.
 */
export function resolveWordPressSiteBase(siteOrigin?: string): string {
  const trimmed = siteOrigin?.trim();
  if (!trimmed) {
    throw new WordPressSiteOriginMissingError();
  }

  const raw = trimmed.replace(/\/$/, "");
  const base = raw.replace(/\/wp-json\/wc\/v3\/?$/i, "");

  if (!base) {
    throw new WordPressSiteOriginMissingError();
  }

  return base;
}

/** Valida siteOrigin sem lançar — usado na montagem do config da loja. */
export function normalizeWordPressSiteOrigin(siteOrigin?: string): string | null {
  try {
    return resolveWordPressSiteBase(siteOrigin);
  } catch {
    return null;
  }
}
